import { Box, styled } from '@grupoboticario/flora-react';

export const styles = {
  HorizontalLine: styled(Box, {
    border: '2px solid $nonInteractiveOutline',
    marginTop: '$10',
  }),
};

export default styles;
